import { IOption } from '@cmps/ng-select';
import { BehaviorSubject } from 'rxjs';

import { ModelTransformer } from '../../../common/common.model';

import { CoachingInsightSessionKeys } from './oa.model';

export const CoachingDateToday = new Date();
// export const CoachingDateToday = new Date('2019-02-24');

export enum CoachingComponentName {
    FLOA = 'FLOA',
    OA = 'OA',
}
export enum CoachingComponentType {
    OA = 0,
    FLOA,
}

export enum PeriodTypeId {
    DAY = '0',
    WEEK = '1',
    MONTH = '2',
    QUARTER = '3',
    ROLLING30 = '4',
    YEAR = '5',
}
export interface AvailablePeriodType {
    isDefault: boolean;
    periodInitials: string;
    periodName: string;
    periodShortName: string;
    periodTypeId: number;
    value?: any;
    label?: string;
}

export interface PersonOfInterest {
    lastName?: string;
    firstName?: string;
    isAvailable?: boolean;
    value?: string;
    label?: string;
    userId?: number;
    favorite?: boolean;
}

export class ColumnConfigItem {
    id: string;
    // memberData?: TeamOAItem;
    index?: number;
    bindToId?: any;
    header?: string = '';
    width?: string;
    display?: boolean = true;
    styles?: any;
    cellstyles?: any;
    colstyle?: any;
    class?: string | string[];
    classes?: string | string[];
    icon?: Icon[];
    bindObservableToMetricId?: number;
    // toggle?: Observable<boolean>;
    active?: boolean = true;
    displayByDefault?: boolean = false;
    headerContentClass?: String;
    elastic?: boolean = false;
    colclass?: string;

    actionSideEffects?: {
        [key: string]: Function;
    };

    cacheStyleProps?: {
        [key: string]: any;
    };

    left?: HeaderExtraContent;
    right?: HeaderExtraContent;

    compactView?: boolean = false;

    templateName?: string;

    constructor(init?: Partial<ColumnConfigItem>, id?: string) {
        Object.assign(this, init);
        this.id = id;
    }

    compress(runSideEffect?: string): ColumnConfigItem {
        if (this.icon) {
            const i = this.icon.find((ss: Icon) => ss.iconName === 'compress');
            if (i) i.toggle();
        }
        this.compactView = !this.compactView;
        if (this.actionSideEffects && runSideEffect) {
            this.actionSideEffects[runSideEffect].call(
                this.actionSideEffects[runSideEffect],
                this,
            );
        }
        return this;
    }

    toggleItem(): ColumnConfigItem {
        if (this.icon) {
            const i = this.icon.find((ss: Icon) => ss.iconName === 'toggle');
            if (i) i.toggle();
        }
        this.active = !this.active;
        return this;
    }

    serialize(): ColumnConfigItemJson {
        return {
            id: this.id,
            styles: this.styles ? this.styles : {},
            colstyle: this.colstyle ? this.colstyle : {},
            active: this.active ? this.active : false,
            cacheStyleProps: this.cacheStyleProps ? this.cacheStyleProps : {},
            compactView: this.compactView ? this.compactView : false,
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            icon: this.icon && this.icon.map((e) => e.serialize()),
        };
    }

    deserialize(value: ColumnConfigItemJson): void {
        if (!value) {
            return;
        }
        Object.entries(value).forEach(([key, val]) => {
            if (key === 'icon') {
                this[key] = val.map((e) => {
                    const i = this.icon.find((c) => c.id === e.id);
                    i.deserialize(e);
                    return i;
                });
            } else {
                this[key] = val;
            }
        });
    }
}

interface ColumnConfigItemJson {
    id: string;
    styles?: any;
    colstyle?: any;
    icon?: IconJson[];
    active?: boolean;
    cacheStyleProps?: {
        [key: string]: any;
    };
    compactView?: boolean;
}

export function saveColumnConfigItems(value: ColumnConfigItem[]): void {
    let columnConfigItem: ColumnConfigItemJson[] = [];
    try {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        columnConfigItem = value && value.map((e) => e.serialize());
    } catch (e) {
        console.log(e);
    }
    const obj = JSON.stringify(columnConfigItem);
    sessionStorage.setItem(CoachingInsightSessionKeys.COLUMN_CONFIG_ITEMS, obj);
}

export function getColumnConfigItems(value: ColumnConfigItem[]): void {
    const obj = sessionStorage.getItem(
        CoachingInsightSessionKeys.COLUMN_CONFIG_ITEMS,
    );
    if (!obj) {
        return;
    }
    const objArr = JSON.parse(obj) as ColumnConfigItemJson[];
    value.forEach((e) => {
        const b = objArr.find((c) => c.id === e.id);
        e.deserialize(b);
    });
}

export interface HeaderExtraContent {
    class?: string;
    content?: string;
}
export class Icon {
    id: string;
    iconName?: string;
    class?: string | string[];
    state?: boolean;
    defaultclass?: string | string[];
    counter?: number;
    action?: string;
    actionParams?: any;
    prop?: string;
    defaultState?: number;
    title?: string | string[];
    actionSideEffect?: Function;

    constructor(init?: Partial<Icon>, id?: string) {
        Object.assign(this, init);
        this.id = id;
    }

    toggle(): boolean {
        if (this.state !== undefined) {
            this.state = !this.state;
            if (this.class && this.counter !== this.class.length - 1) {
                this.counter++;
            } else this.counter = 0;

            return this.state;
        }
        return null;
    }

    serialize(): IconJson {
        return {
            id: this.id,
            state: this.state,
            counter: this.counter,
        };
    }

    deserialize(value: IconJson): void {
        if (!value) {
            return;
        }
        Object.entries(value).forEach(([key, val]) => {
            this[key] = val;
        });
    }
}

interface IconJson {
    id: string;
    state?: boolean;
    counter?: number;
}

export interface ExtCoachingInsightComponent {
    componentTypeId: number;
    thresholdColour: string;
    componentInitials: string;
    componentShortName: string;
    componentName: string;
    displayValue: number;
    displayOrder: number;
    totalOpportunities: number;
    expectedOpportunities: number;
    coachedOpportunities: number;
    lastUpdated: Date;
    coachingInsightSubComponents?: CoachingInsightSubComponent[];
    coachingInsightAttributes?: any[];
}

export class CoachingInsightConfig {
    attributes: CoachingInsightConfigAttribute[];
    peopleOfInterest: PersonOfInterest[];
    availablePeriodTypes: AvailablePeriodType[];
    componentAttributes: CoachingInsightConfigAttribute[];
}
export class CoachingInsightConfigAttribute {
    attributeName?: string;
    attributeValue?: string;
    componentTypeId?: number;
}
export interface CoachingInsightComponentAttributes {
    expectedOpportunities?: number;
    totalOpportunities?: number;
    coachedOpportunities?: number;
    lastUpdated?: Date;
    defaultExpandWidget?: boolean;
    commitmentCountMax?: number;
    commitmentCountWarn?: number;
    fundedCoachedOpps?: number;
    pctAgentsWithOpps?: number;
    totalAgents?: number;
}
export class CoachingInsightComponent {
    public componentTypeId?: number;
    public thresholdColour?: string;
    public componentInitials?: string;
    public componentShortName?: string;
    public componentName?: string;
    public displayValue?: number;
    public displayOrder?: number;
    public totalOpportunities?: number;
    public expectedOpportunities?: number;
    public coachedOpportunities?: number;
    public lastUpdated?: Date;
    public iconstate?: boolean = false;
    public toggle?: BehaviorSubject<boolean>;
    public coachingInsightSubComponents?: CoachingInsightSubComponent[];
    public componentAttributes?: CoachingInsightComponentAttributes;

    constructor(init?: Partial<CoachingInsightComponent>) {
        Object.assign(this, init);

        if (this.displayValue == null || this.componentTypeId == null) {
            console.error('Invalid CoachingInsightComponent.', this);
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    closeAll() {
        this.coachingInsightSubComponents.forEach((menu) => {
            menu.active = false;
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    toggleSubmenu(id) {
        this.coachingInsightSubComponents.forEach((s) => {
            if (s.subComponentTypeId === id) {
                if (s.active === true) s.active = false;
                else s.active = true;
            }
        });
    }
}
export interface CoachingInsightSubComponent {
    subComponentTypeId: number;
    componentTypeId: number;
    subComponentInitials: string;
    subComponentShortName: string;
    subComponentName: string;
    displayOrder: number;
    displayValue: number;
    displayFormat: string;
    thresholdColour: string;
    active?: boolean;
}
export interface CoachingSummaryResponse {
    components?: ExtCoachingInsightComponent[];
    subcomponents?: CoachingInsightSubComponent[];
    attributes?: CoachingInsightConfigAttribute[];
}

export class CoachingComponentsTransformer
    implements
        ModelTransformer<CoachingInsightComponent[], CoachingSummaryResponse>
{
    transform(model: CoachingSummaryResponse): CoachingInsightComponent[] {
        const components: ExtCoachingInsightComponent[] = model.components;
        let subcomponents: CoachingInsightSubComponent[] = model.subcomponents;
        const attributes: CoachingInsightConfigAttribute[] = model.attributes;

        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (subcomponents && subcomponents.length) {
            subcomponents.sort(function (a, b) {
                return a.displayOrder - b.displayOrder;
            });
            subcomponents.forEach((d) => {
                // eslint-disable-next-line @typescript-eslint/prefer-includes
                d.thresholdColour =
                    // eslint-disable-next-line @typescript-eslint/prefer-includes
                    !d.thresholdColour || d.thresholdColour.indexOf('FFF') > -1
                        ? '#000'
                        : // eslint-disable-next-line @typescript-eslint/prefer-includes
                        d.thresholdColour.indexOf('#') === -1
                        ? `#${d.thresholdColour}`
                        : d.thresholdColour;
                return d;
            });
            // non-oa?
            const noa = subcomponents.find((f) => f.subComponentTypeId === 0);
            // non-kpi?
            const nkp = subcomponents.find((f) => f.subComponentTypeId === 1);

            if (!noa) {
                subcomponents.push({
                    componentTypeId: 0,
                    displayFormat: null,
                    displayOrder: 0,
                    displayValue: null,
                    subComponentInitials: 'Non-OA',
                    subComponentName: 'Non-Opportunity',
                    subComponentShortName: 'Non-OA',
                    subComponentTypeId: 0,
                    thresholdColour: 'FFF',
                    active: false,
                });
            }
            if (!nkp) {
                subcomponents.push({
                    componentTypeId: 0,
                    displayFormat: null,
                    displayOrder: 0,
                    displayValue: null,
                    subComponentInitials: 'Non-KPI',
                    subComponentName: 'Non-KPI',
                    subComponentShortName: 'Non-KPI',
                    subComponentTypeId: 1,
                    thresholdColour: 'FFF',
                    active: false,
                });
            }
        } else {
            subcomponents = [
                {
                    componentTypeId: 0,
                    displayFormat: null,
                    displayOrder: 0,
                    displayValue: null,
                    subComponentInitials: 'Non-OA',
                    subComponentName: 'Non-Opportunity',
                    subComponentShortName: 'Non-OA',
                    subComponentTypeId: 0,
                    thresholdColour: 'FFF',
                    active: false,
                },
                {
                    componentTypeId: 0,
                    displayFormat: null,
                    displayOrder: 0,
                    displayValue: null,
                    subComponentInitials: 'Non-KPI',
                    subComponentName: 'Non-KPI',
                    subComponentShortName: 'Non-KPI',
                    subComponentTypeId: 1,
                    thresholdColour: 'FFF',
                    active: false,
                },
            ];
        }

        // always add Missed Opps button
        // subcomponents.push({
        //     componentTypeId: 0, // only show missed opps in Coaching Component : "OA"
        //     displayFormat: null,
        //     displayOrder: 99,
        //     displayValue: null,
        //     subComponentInitials: 'MO',
        //     subComponentName: 'Missed Opps.',
        //     subComponentShortName: 'Missed Opps.',
        //     subComponentTypeId: 99,
        //     thresholdColour: 'FFF',
        //     active: false
        // })

        // on load, all metrics are in an inactive (unclicked) state
        const comps = components.map(
            (extcomponent: ExtCoachingInsightComponent) => {
                const x = new CoachingInsightComponent({
                    componentTypeId: extcomponent.componentTypeId,
                    thresholdColour: extcomponent.thresholdColour,
                    componentInitials: extcomponent.componentInitials,
                    componentShortName: extcomponent.componentShortName,
                    componentName: extcomponent.componentName,
                    displayOrder: extcomponent.displayOrder,
                    displayValue: extcomponent.displayValue,
                    lastUpdated: extcomponent.lastUpdated,
                    iconstate: false,
                    coachingInsightSubComponents: subcomponents.filter(
                        (g) =>
                            g.componentTypeId === extcomponent.componentTypeId,
                    ), // must filter by DiagnosticComponentTypeId
                });

                if (extcomponent.displayValue != null) {
                    x.displayValue =
                        extcomponent.displayValue > 100
                            ? 100
                            : extcomponent.displayValue;
                }

                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                if (attributes && attributes.length) {
                    const cattributes = attributes.filter(
                        (d) =>
                            d.componentTypeId === extcomponent.componentTypeId,
                    );
                    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                    if (cattributes && cattributes.length) {
                        x.componentAttributes =
                            transformAttributesToComponentAttributes(
                                cattributes,
                            );
                    }
                }
                x.closeAll();
                return x;
            },
        );

        // temporarily default to an empty OA if no components returned for user
        if (!comps.length) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            comps.push({
                componentInitials: 'No Data',
                componentName: '-',
                componentShortName: 'No Data',
                componentTypeId: null,
                displayOrder: 0,
                displayValue: null,
                thresholdColour: '#000',
                iconstate: false,
                // coachingInsightSubComponents: subcomponents
            } as CoachingInsightComponent);
        }
        // else if (comps.length == 1) {
        //     comps.push(<CoachingInsightComponent>{
        //         componentInitials: 'FLOA',
        //         componentName: 'Frontline OA',
        //         componentShortName: 'FLOA',
        //         componentTypeId: 1,
        //         displayOrder: 1,
        //         displayValue: 60,
        //         thresholdColour: 'red',
        //         iconstate: false,
        //     });
        // }

        return comps;
    }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getMonthStart(date) {
    if (!date) {
        console.error('Please provide valid date');
        return null;
    }
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function addDays(date: any, days: number) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    const d = new Date(new Date(date).setDate(date.getDate() + days));
    return d;
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function endOfWeek(date: Date) {
    const lastday = date.getDate() - (date.getDay() - 1) + 6;
    return new Date(date.setDate(lastday));
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getQuarter(today) {
    const quarter = Math.floor(today.getMonth() / 3);
    let startDate;
    let endDate;

    // eslint-disable-next-line prefer-const
    startDate = new Date(today.getFullYear(), quarter * 3, 1);
    // eslint-disable-next-line prefer-const, @typescript-eslint/restrict-plus-operands
    endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);

    return {
        StartDate: startDate,
        EndDate: endDate,
    };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function allPropsNull(obj: any) {
    for (const c in obj) {
        if (obj[c] != null) return false;
    }
    return true;
}

/* TODO remove. unused */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isNullOrEmptyObject(obj) {
    if (obj === null || obj === undefined) return true;
    if (typeof obj !== 'object') return false;
    for (const c in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(c)) {
            return false;
        }
    }
    return true;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function prependEmptyOption(arr: any[], placeholdertext) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    arr.unshift({ value: null, label: placeholdertext } as IOption);
}

export function getUniqueFromSet(dataset: any[], field: string): any[] {
    const unique = [];
    dataset.forEach((c) => {
        const comm = unique.find((s) => s[field] === c[field]);
        if (!comm) {
            unique.push(c);
        }
    });
    return unique;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function mapper(data) {
    if (!data.isSuccess) {
        throw new Error(data.message);
    }
    return data.entity;
}

export function transformAttributesToComponentAttributes(
    attributes: CoachingInsightConfigAttribute[],
): CoachingInsightComponentAttributes {
    const componentAttributes: CoachingInsightComponentAttributes = {};

    if (attributes?.length > 0) {
        attributes.forEach((a) => {
            // handle dd-mm-yyyy
            if (a.attributeName === 'lastUpdated') {
                let lastUpdated = a.attributeValue;
                let spl = lastUpdated.split('-');
                if (spl.length === 3 && spl[2].length === 4) {
                    spl = [spl[2], spl[1], spl[0]];
                    lastUpdated = spl.join('-');
                }

                componentAttributes[a.attributeName] = new Date(lastUpdated);
            } else {
                componentAttributes[a.attributeName] = a.attributeValue;
            }
        });
    }

    return componentAttributes;
}
